"use strict";

import React from "react";

/** Used to inject a baseClassName into a component **/
function withBaseClass(Component, baseClassName) {
  return class extends React.Component {
    render() {
      return <Component baseClassName={baseClassName} {...this.props} />;
    }
  };
}

export default withBaseClass;
